import img3 from "../src/images/online.jpg";
import img2 from "../src/images/olds.jpg";
import img1 from "../src/images/market.jpg";
import img4 from "../src/images/shirt/sahil-moosa-m1MRYp556Ew-unsplash.jpg";
import img5 from "../src/images/suit.jpg";
import img6 from "../src/images/yung.jpg";


export const sliderItems= [
    {
       id:1,
       img:img3,
       title:"BUMPER SALE",
       desc:"DONT COMPROMISE WITH FASHIONE !! GET FLAT 30% OFF FOR NEW ARRIVALS.",
       bg:"f5faf5",
    },
    {
        id:2,
        img:img1,
        title:"MEN'S SALE",
        desc:"DONT COMPROMISE WITH FASHIONE !! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg:"f5faf6",
     },
     {
        id:3,
        img:img2,
        title:"WOMEN'S SALE",
        desc:"DONT COMPROMISE WITH FASHIONE !! GET FLAT 30% OFF FOR NEW ARRIVALS.",
        bg:"f5faf7",
     },

]

export const categories=[
   {
      id:1,
      img:img4,
      title:"SHIRT STYLE!",
      cat:"shirt"
   },
   {
      id:2,
      img:img5,
      title:"WOMEN SUIT!",
      cat:"women"

   },
   {
      id:3,
      img:img6,
      title:"CHILD WEAR!",
      cat:"girls"

   },
]
